// extracted by mini-css-extract-plugin
module.exports = {"shorts":"ShortsYoutubePlayer_shorts__Ot3td","video-wrapper":"ShortsYoutubePlayer_video-wrapper__k4cDt"};